<div *ngFor="let link of links" class="show-mode attr-height">
    <div class="url-width">
        <span>URL</span>
    </div>
    <div class="url-value-width">
        <span class="long-label" (click)="openLink(link.AttributeValue)" style="cursor: pointer;"
            title="{{link.AttributeValue}}">{{link.AttributeValue}}</span>
    </div>
    <div class="url-label-width">
        <span>URL Label</span>
    </div>
    <div class="url-value-width">
        <span class="long-label" title="{{link.Description}}">{{link.Description}}</span>
    </div>
</div>
